<ph-field>
    <ph-field inline>
        <ph-checkbox
            [checked]="value"
            [disabled]="disabled"
            [ariaLabel]="section.label"
            (ph-change)="onChange($event.detail)">
        </ph-checkbox>
        <ph-label>{{ section.label }}</ph-label>
    </ph-field>
    <ph-hint *ngIf="section.description">{{ section.description }}</ph-hint>
</ph-field>
